import { render } from "./DialogFTColorList.vue?vue&type=template&id=349e7d3c"
import script from "./DialogFTColorList.vue?vue&type=script&lang=js"
export * from "./DialogFTColorList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__